import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServicesImageMockupPage from './pages/ServicesImageMockupPage';
import AboutPage from './pages/AboutPage';
import NewsletterPage from './pages/NewsletterPage';
import WaterGuidePage from './pages/WaterGuidePage';
import WordPressContentPage from './pages/WordPressContentPage';
import NotFoundPage from './pages/NotFoundPage';
import ContactPage from './pages/ContactPage';
import './App.css';

function TitleUpdater() {
  const location = useLocation();
  
  useEffect(() => {
    let path = location.pathname.replace('/aquify', '').replace(/\/$/, '') || '/';
    
    switch (path) {
      case '/':
        document.title = 'Aquify';
        break;
      case '/services':
        document.title = 'Services | Aquify';
        break;
      case '/about':
        document.title = 'About | Aquify';
        break;
      case '/water-guide':
        document.title = 'Water Guide | Aquify';
        break;
      case '/newsletter':
        document.title = 'Newsletter | Aquify';
        break;
      case '/contact':
        document.title = 'Contact | Aquify';
        break;
      default:
        if (window.aquifyConfig?.currentPage) {
          document.title = window.aquifyConfig.currentPage.documentTitle || window.aquifyConfig.currentPage.title;
        } else {
          document.title = 'Page Not Found | Aquify';
        }
        break;
    }
  }, [location]);

  return null;
}

function ScrollManager() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const sectionId = decodeURIComponent(location.hash.replace('#', ''));
      const timeoutId = window.setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
      return () => window.clearTimeout(timeoutId);
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [location.pathname, location.hash]);

  // Handle repeated clicks on the identical hash link
  useEffect(() => {
    const handleHashClick = (e) => {
      const target = e.target.closest('a');
      if (!target) return;
      
      const href = target.getAttribute('href');
      if (href && href.includes('#')) {
        const [path, hash] = href.split('#');
        // If path is empty, or equals the current pathname
        const isSamePath = !path || path === location.pathname || path === location.pathname.replace(/\/$/, '');
        if (isSamePath && `#${hash}` === location.hash) {
          const sectionId = decodeURIComponent(hash);
          const section = document.getElementById(sectionId);
          if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }
    };
    
    document.addEventListener('click', handleHashClick);
    return () => document.removeEventListener('click', handleHashClick);
  }, [location]);

  return null;
}

export default function App() {
  const hasWpPage = !!window.aquifyConfig?.currentPage;

  return (
    <BrowserRouter>
      <TitleUpdater />
      <ScrollManager />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services-mockup" element={<ServicesImageMockupPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/newsletter" element={<NewsletterPage />} />
        <Route path="/water-guide" element={<WaterGuidePage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* WordPress / XAMPP fallback */}
        <Route path="/aquify" element={<HomePage />} />
        <Route path="/aquify/" element={<HomePage />} />
        <Route path="/aquify/services" element={<ServicesPage />} />
        <Route path="/aquify/about" element={<AboutPage />} />
        <Route path="/aquify/newsletter" element={<NewsletterPage />} />
        <Route path="/aquify/water-guide" element={<WaterGuidePage />} />

        {/* Catch-all fallback */}
        <Route path="*" element={hasWpPage ? <WordPressContentPage /> : <NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}